import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { withProps, compose, lifecycle } from 'recompose'
import withNormalizeValue from 'components/common/hoc/withNormalizeValue'
import isEqual from 'lodash/isEqual'
import { VEHICLE_DETAILS_FORM } from '../constants'
import { handleSubmit, resetForm, getStatesApi, resetFormFields } from './actions'
import { createInitialValues, getStatesOptions } from './helpers'
import createViewModel from './viewModel'
import VehicleDetails from './VehicleDetails'
import { getStates, getValues } from '../selectors'
import validate from './validate'

const mapStateToProps = state => {
  const { licencePlateNumber } = getValues(state) || {}
  return {
    licencePlateNumber,
    personalizationValues: getValues(state),
    states: getStates(state)
  }
}

const withLifecycles = lifecycle({
  componentDidMount() {
    const { getStatesApi, states } = this.props
    if (!states || !states.length) { getStatesApi() }
  },
  componentDidUpdate({ licencePlateNumber: prevLicencePlateNumber }) {
    const { licencePlateNumber, resetFormFields } = this.props
    if (!isEqual(licencePlateNumber, prevLicencePlateNumber) && !licencePlateNumber) {
      resetFormFields({ state: null })
    }
  },
  componentWillUnmount() {
    this.props.resetForm()
  }
})

const withVehicleProps = withProps(({
  vehicleCompatibleSizes = [],
  userVehicleDetails,
  vehicleEngineType = [],
  states
}) => {
  const stateOptions = getStatesOptions(states)
  return {
    model: createViewModel({
      userVehicleDetails,
      stateOptions,
      vehicleEngineType,
      vehicleCompatibleSizes
    }),
    initialValues: createInitialValues({
      userVehicleDetails,
      vehicleEngineType
    })
  }
})

export default compose(
  connect(mapStateToProps, { resetForm, getStatesApi, resetFormFields }),
  withLifecycles,
  withVehicleProps,
  reduxForm({ validate, form: VEHICLE_DETAILS_FORM, onSubmit: handleSubmit, forceUnregisterOnUnmount: true }),
  withNormalizeValue
)(VehicleDetails)
